import { jsx as l } from "react/jsx-runtime";
const a = () => /* @__PURE__ */ l(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.189 19.61a5.25 5.25 0 1 1 8.872-2.208m0 .001c-.156.407-.36.791-.606 1.147l1.339 1.29a.662.662 0 0 1 .152.74.706.706 0 0 1-.651.42H16a.715.715 0 0 1-.076-.004 5.859 5.859 0 0 1-2.72-.551 5.272 5.272 0 0 1-1.015-.834m-1.89.006H3a.75.75 0 0 1-.53-1.28l2.34-2.342a8.683 8.683 0 1 1 15.739-4.982 6.75 6.75 0 0 0-10.25 8.603Z",
    fill: "currentColor"
  }
);
export {
  a as default
};
